var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.058 10.2891L4.01403 0.564141C3.71068 0.380438 3.36393 0.280699 3.00933 0.275147C2.65474 0.269596 2.30504 0.358431 1.99609 0.532549C1.68713 0.706666 1.43003 0.959803 1.25114 1.26602C1.07224 1.57223 0.977985 1.9205 0.978028 2.27514V21.7251C0.977878 22.0799 1.07211 22.4284 1.25106 22.7347C1.43 23.0411 1.68722 23.2943 1.99633 23.4685C2.30544 23.6426 2.65532 23.7314 3.01006 23.7257C3.36481 23.72 3.71165 23.6201 4.01503 23.4361L20.058 13.7111C20.3524 13.533 20.5958 13.2819 20.7647 12.9822C20.9337 12.6824 21.0224 12.3442 21.0224 12.0001C21.0224 11.6561 20.9337 11.3178 20.7647 11.0181C20.5958 10.7184 20.3524 10.4673 20.058 10.2891Z",
    fill: "#0088A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.a37c3ae5f4f6637914c109990344b15a.svg";
export { ForwardRef as ReactComponent };